import { Clickable } from 'src/shared/design-system/Utilities';
import styled from 'styled-components';
import { ifProp } from 'web-common/src/shared/styled-utils/ifProp';
import { Border, Colors, Font, Mixins, Spacing } from 'web-common/src/shared/styles';

export const RowContainer = styled.div<{ dividerBelow?: boolean; inlineInput?: boolean; disabled?: boolean }>`
  align-items: ${ifProp('inlineInput', 'center', 'flex-start')};
  display: flex;
  flex-direction: ${ifProp('inlineInput', 'row', 'column')};
  justify-content: flex-start;
  gap: ${Spacing.SINGLE};
  padding: ${Spacing.SINGLE_QUARTER} 0;
  opacity: ${ifProp('disabled', '0.4', '1')};
  ${ifProp('dividerBelow', `border-bottom: ${Border.Base} ${Colors.GRAY_LITE_10};`)}
`;

export const RowTextContainer = styled.div`
  flex: 1;
  ${Mixins.Flex.setColumn('center', 'flex-start')}
`;

export const RowTitleContainer = styled.div<{ hasDescription?: boolean }>`
  color: ${Colors.GRAY_DARK_30};
  gap: ${Spacing.THREE_QUARTERS};
  align-items: center;
  margin: ${ifProp('hasDescription', Spacing.HALF, 0)} 0;
  ${Mixins.Flex.set()}
`;

export const RowTitle = styled.h3`
  margin: 0;
  ${Font.bySize(Font.Size.S, Font.Weight.SEMI_BOLD)}
`;

export const RowIconContainer = styled.div`
  ${Mixins.Flex.centerColumn()}

  & svg {
    ${Mixins.Shape.square(Spacing.DOUBLE)}
  }
`;

export const RowDescriptionContainer = styled.div`
  gap: ${Spacing.HALF};
  ${Mixins.Flex.setColumn()};
`;

export const RowDescription = styled.div`
  color: ${Colors.GRAY_DARK_10};
  ${Font.bySize(Font.Size.XS, Font.Weight.NORMAL)}
`;

export const RowInputContainer = styled.div<{ inlineInput?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${ifProp('inlineInput', 'flex-end', 'flex=start')};
`;

export const RowYesNoInputContainer = styled.div<{ largerToggle?: boolean }>`
  width: ${ifProp('largerToggle', '232px', '144px')};
`;

export const LearnMoreLink = styled(Clickable)`
  cursor: pointer;
  color: ${Colors.GRAY_DARK_30};
  ${Font.bySize(Font.Size.XS, Font.Weight.SEMI_BOLD)}

  &:hover {
    color: ${Colors.AQUA_DARK_20};
  }
`;
